import { Item } from '@invoice-simple/domain-invoicing';
import { QueryFunctionContext, QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import UserModel from 'src/models/UserModel';

export interface SearchItemsResponse {
  items: Item[];
}

interface QueryError {
  message: string;
}

export interface SearchItemsParams {
  searchTerm?: string;
}

export const fetchItems = async ({
  queryKey
}: QueryFunctionContext): Promise<SearchItemsResponse> => {
  const { headers } = UserModel.getInstance().getApiReqOpts();

  const [_, searchTerm] = queryKey;

  const { data } = await axios.get<SearchItemsResponse>(
    `${process.env.REACT_APP_URL ?? 'https://localhost:3000'}/api/items/search`,
    {
      headers,
      params: {
        q: searchTerm
      }
    }
  );

  return data;
};

export const useSearchItems = (
  { searchTerm }: SearchItemsParams,
  options?: UseQueryOptions<SearchItemsResponse, QueryError, SearchItemsResponse, QueryKey>
) => {
  return useQuery<SearchItemsResponse, QueryError>(['itemsSearch', searchTerm], fetchItems, {
    enabled: !!searchTerm,
    ...options
  });
};
